import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { Field } from 'redux-form/immutable';
import { Grid } from '@material-ui/core';
import messages from 'containers/ApplicationFormPage/messages';
import FormSelect from 'components/FormSelect';
import { productCodeCheck } from 'helpers/constants';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { makeSelectOption } from 'containers/App/selectors';
import { createStructuredSelector } from 'reselect';

function ReasonForPurchase(props) {
  const intl = useIntl();
  const { change, formValues, options, isInforce, oowDetails, initialValues } = props;
  const { productCode, productConfigs } = formValues;

  let reasonForPurchaseOption = [];
  let reasonForPurchaseDisabled = false;
  if (
    productCodeCheck('SIM', productCode) ||
    productCodeCheck('WAP', productCode) ||
    productCodeCheck('IWA', productCode)
  ) {
    reasonForPurchaseOption = options.reasonForPurchase.option1;
    reasonForPurchaseDisabled = true;
  } else if (
    productCodeCheck('RSP', productCode) ||
    productCodeCheck('GC', productCode) ||
    productCodeCheck('VISTA', productCode)
  ) {
    reasonForPurchaseOption = options.reasonForPurchase.option2;
  } else if (productCodeCheck('ESP', productCode)) {
    reasonForPurchaseOption = options.reasonForPurchase.option3;
    reasonForPurchaseDisabled = true;
  } else if (productCodeCheck('SACI', productCode)) {
    const coverages = productConfigs.coverages[0];
    const reasonForPurchaseTitle = coverages?.CCC.selected
      ? coverages?.CCC.name
      : coverages?.CRI.name;
    reasonForPurchaseOption = options.reasonForPurchase.option4.filter(option =>
      option.title.toLowerCase().includes(reasonForPurchaseTitle.toLowerCase()),
    );
    reasonForPurchaseDisabled = true;
  } else if (isInforce && productCodeCheck('FUTU', productCode)) {
    reasonForPurchaseOption = options.reasonForPurchase.option5;
  }
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (reasonForPurchaseOption.length === 1) {
      change(`reasonForPurchase`, reasonForPurchaseOption[0].value);
    }
  });

  useEffect(() => {
    if (initialized) return;
    if (isInforce) {
      if (oowDetails && oowDetails.policyPurposeCode)
      {
        if(initialValues.reasonForPurchase)
          change(`reasonForPurchase`, initialValues.reasonForPurchase);
        else 
          change(`reasonForPurchase`, oowDetails.policyPurposeCode);
      }
    }
    // setInitialized(true);
  }, [oowDetails, change, initialValues]);

   function handleRFPChange(e) {
    change(`reasonForPurchase`, e.target.value);
    setInitialized(true);
  } 

  return (
    <>
      {reasonForPurchaseOption.length > 0 ? (
        <Grid item>
          <Field
            name="reasonForPurchase"
            component={FormSelect}
            options={[
              {
                value: 'Select an option',
                title: 'Select an option',
              },
              ...reasonForPurchaseOption,
            ]}
            label={<FormattedMessage {...messages.reasonForPurchase} />}
            placeholder={intl.formatMessage(messages.pleaseEnter)}
            type="text"
            color="primary"
            margin="normal"
            variant="standard"
            fullWidth
            disabled={reasonForPurchaseDisabled}
            onChange={handleRFPChange}
            style={{ width: 260, marginBottom: 20 }}
          />
        </Grid>
      ) : (
        ''
      )}
    </>
  );
}

ReasonForPurchase.propTypes = {
  fields: PropTypes.object,
  change: PropTypes.func,
  formValues: PropTypes.object,
  formErrors: PropTypes.object,
  options: PropTypes.object,
  isInforce: PropTypes.bool,
  oowDetails : PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
  options: makeSelectOption(),
});

function mapDispatchToProps() {
  return {};
}
const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(ReasonForPurchase);
